export default "__VITE_ASSET__ChdAdpDn__";